export const Step1Text = {
  Button: {
    Next: () => (
      <span>
        <strong>NEXT:</strong> Select Accounts
      </span>
    ),
  },
  Title: () => <span>Choose delivery method for your assets</span>,
};

export const Step2Text = {
  Button: {
    Next: () => (
      <span>
        <strong>NEXT:</strong> Review & Submit
      </span>
    ),
  },
  Title: () => <span>Select your account(s)</span>,
};

export const Step3Text = {
  Button: {
    Next: () => <span>Submit</span>,
  },
  Title: () => <span>Review and submit</span>,
};
